import { TenantEntity } from '@/class/model/TenantEntity'

export class FbaWarehouseInDetail extends TenantEntity {
  constructor(data) {
    super(data)
    this.className = 'FbaWarehouseInDetail'
  }
  get sequenceNo() {
    return this._data.sequenceNo
  }
  set sequenceNo(sequenceNo) {
    this._data.sequenceNo = sequenceNo || 0
  }
  get containerNo() {
    return this._data.containerNo
  }
  set containerNo(containerNo) {
    this._data.containerNo = containerNo || ''
  }
  get poNumber() {
    return this._data.poNumber
  }
  set poNumber(poNumber) {
    this._data.poNumber = poNumber || 0
  }
  get shipmentId() {
    return this._data.shipmentId
  }
  set shipmentId(shipmentId) {
    this._data.shipmentId = shipmentId || ''
  }
  get referenceId() {
    return this._data.referenceId
  }
  set referenceId(referenceId) {
    this._data.referenceId = referenceId || ''
  }
  get boxesNumber() {
    return this._data.boxesNumber
  }
  set boxesNumber(boxesNumber) {
    this._data.boxesNumber = boxesNumber || 0
  }
  get singleBoxWeight() {
    return this._data.singleBoxWeight
  }
  set singleBoxWeight(singleBoxWeight) {
    this._data.singleBoxWeight = singleBoxWeight || 0
  }
  get boxLength() {
    return this._data.boxLength
  }
  set boxLength(boxLength) {
    this._data.boxLength = boxLength || 0
  }
  get boxWidth() {
    return this._data.boxWidth
  }
  set boxWidth(boxWidth) {
    this._data.boxWidth = boxWidth || 0
  }
  get boxHeight() {
    return this._data.boxHeight
  }
  set boxHeight(boxHeight) {
    this._data.boxHeight = boxHeight || 0
  }
  get chargeWeight() {
    return this._data.chargeWeight
  }
  set chargeWeight(chargeWeight) {
    this._data.chargeWeight = chargeWeight || 0
  }
  get volumetricWeight() {
    return this._data.volumetricWeight
  }
  set volumetricWeight(volumetricWeight) {
    this._data.volumetricWeight = volumetricWeight || 0
  }
  get cargoEnglishName() {
    return this._data.cargoEnglishName
  }
  set cargoEnglishName(cargoEnglishName) {
    this._data.cargoEnglishName = cargoEnglishName || ''
  }
  get cargoChineseName() {
    return this._data.cargoChineseName
  }
  set cargoChineseName(cargoChineseName) {
    this._data.cargoChineseName = cargoChineseName || ''
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency || ''
  }
  get unitRate() {
    return this._data.unitRate
  }
  set unitRate(unitRate) {
    this._data.unitRate = unitRate || 0
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity || 0
  }
  get hsCode() {
    return this._data.hsCode
  }
  set hsCode(hsCode) {
    this._data.hsCode = hsCode || ''
  }
  get brand() {
    return this._data.brand
  }
  set brand(brand) {
    this._data.brand = brand || ''
  }
  get brandType() {
    return this._data.brandType
  }
  set brandType(brandType) {
    this._data.brandType = brandType || ''
  }
  get modelNo() {
    return this._data.modelNo
  }
  set modelNo(modelNo) {
    this._data.modelNo = modelNo || ''
  }
  get skuNo() {
    return this._data.skuNo
  }
  set skuNo(skuNo) {
    this._data.skuNo = skuNo || ''
  }
  get upcNo() {
    return this._data.upcNo
  }
  set upcNo(upcNo) {
    this._data.upcNo = upcNo || ''
  }
  get materialQuality() {
    return this._data.materialQuality
  }
  set materialQuality(materialQuality) {
    this._data.materialQuality = materialQuality || ''
  }
  get purpose() {
    return this._data.purpose
  }
  set purpose(purpose) {
    this._data.purpose = purpose || ''
  }
  get salesLink() {
    return this._data.salesLink
  }
  set salesLink(salesLink) {
    this._data.salesLink = salesLink || ''
  }
  get salesPrice() {
    return this._data.salesPrice
  }
  set salesPrice(salesPrice) {
    this._data.salesPrice = salesPrice || 0
  }
  get originPlace() {
    return this._data.originPlace
  }
  set originPlace(originPlace) {
    this._data.originPlace = originPlace || ''
  }
  get pictureUrl() {
    return this._data.pictureUrl
  }
  set pictureUrl(pictureUrl) {
    this._data.pictureUrl = pictureUrl || ''
  }
  get weight() {
    return this._data.weight
  }
  set weight(weight) {
    this._data.weight = weight || 0
  }
  get asin() {
    return this._data.asin
  }
  set asin(asin) {
    this._data.asin = asin || ''
  }
  get cargoType() {
    return this._data.cargoType
  }
  set cargoType(cargoType) {
    this._data.cargoType = cargoType || ''
  }
  get electric() {
    return this._data.electric
  }
  set electric(electric) {
    this._data.electric = electric || false
  }
  get magnetic() {
    return this._data.magnetic
  }
  set magnetic(magnetic) {
    this._data.magnetic = magnetic || false
  }
  get powdery() {
    return this._data.powdery
  }
  set powdery(powdery) {
    this._data.powdery = powdery || false
  }
  get liquid() {
    return this._data.liquid
  }
  set liquid(liquid) {
    this._data.liquid = liquid || false
  }
  get productDescription() {
    return this._data.productDescription
  }
  set productDescription(productDescription) {
    this._data.productDescription = productDescription || ''
  }
  get warehouseInUuid() {
    return this._data.warehouseInUuid
  }
  set warehouseInUuid(warehouseInUuid) {
    this._data.warehouseInUuid = warehouseInUuid || ''
  }
  get palletUuid() {
    return this._data.palletUuid
  }
  set palletUuid(palletUuid) {
    this._data.palletUuid = palletUuid || ''
  }
  get palletNo() {
    return this._data.palletNo
  }
  set palletNo(palletNo) {
    this._data.palletNo = palletNo || ''
  }
  get outWarehouseUuid() {
    return this._data.outWarehouseUuid
  }
  set outWarehouseUuid(outWarehouseUuid) {
    this._data.outWarehouseUuid = outWarehouseUuid || ''
  }
  get batchNo() {
    return this._data.batchNo
  }
  set batchNo(batchNo) {
    this._data.batchNo = batchNo || ''
  }
}
